export default __webpack_public_path__ + "static/grenette-regular-pro-9159dc713f6a53380720a0562eb07c86.woff";